import { hooks } from "./hookactions"

export let SPCSymbolPC = { hooks }
